(($, Drupal) => {
  Drupal.behaviors.corporateImageSlider = {
    attach: function attch(context) {
      $('.js-corporate-image-slider', context).once('slider').each((index, element) => {
        const count = $(element).children().length;
        const counter = $(element).parent().find('.corporate-slider-counter');
        if (count > 1 && window.matchMedia('(min-width: 1024px)').matches) {
          counter.show();
        }
        const slick = $(element).slick({
          arrows: true,
          prevArrow: $(element).parent().find('.corporate-slider-btn.arr-left'),
          nextArrow: $(element).parent().find('.corporate-slider-btn.arr-right'),
          autoplay: true,
          dots: true,
          draggable: true,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        });
        counter.html(`${'<span>1</span>' + '/' + '<span>'}${count}</span>`);
        $(element).on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
          const i = (currentSlide || 0) + 1;
          counter.html(`<span>${i}</span>` + '/' + `<span>${slick.slideCount}</span>`);
        });

        $(element).find('.slick-slide').on('click', function () {
          const slideIndex = $(this).index();
          setTimeout(() => {
            $(element).slick('slickGoTo', slideIndex - 2);
          }, 100);
        });

        $('.corporate-slider__img--wrapper').on('click', function () {
          $(this).find('a.link')[0].click();
        });
        $('.corporate-slider__img--wrapper').mouseover(function () {
          $(this).find('.arrow-wrapper').addClass('hover');
        });
        $('.corporate-slider__img--wrapper').mouseout(function () {
          $(this).find('.arrow-wrapper').removeClass('hover');
        });
      });
    },
  };
})(jQuery, Drupal);
